//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

module.exports = {
    actionElements: require('./actionElements'),
    detailPanes: require('./detailPanes'),
    dialogs: require('./dialogs'),
    formButtons: require('./formButtons'),
    hNode: require('./hNode'),
    layouts: require('./layouts'),
    navHeadings: require('./navHeadings'),
    pages: require('./pages'),
};


